<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Minutas </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="content_accion">
        <div>
          <v-text-field
            v-model="search"
            label="Búsqueda"
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            hide-details
            class="filter"
          ></v-text-field>
        </div>
        <div>
          <v-btn
            icon="mdi-reload"
            size="small"
            variant="outlined"
            color="indigo-darken-3"
            class="mr-2 reload"
            @click="getMinutas()"
          >
          </v-btn>
          <v-btn
            v-bind="props"
            class="text-none mb-4"
            prepend-icon="mdi-plus"
            color="indigo-darken-3"
            @click="openDialogRegistrar()"
          >
            Registrar
          </v-btn>
        </div>
      </div>
      <div class="container_table">
        <v-data-table
          class="content_table"
          :headers="headerMinutas"
          fixed-header
          :items="listAllMinutas"
          :search="search"
          :loading="loadingMinutas"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <tr>
              <td>
                <div class="actions">
                  <div class="actions">
                    <v-tooltip activator="parent" location="top"
                      >Eliminar</v-tooltip
                    >
                    <v-btn
                      class="edit"
                      icon="mdi-delete"
                      color="error"
                      @click="openDialogDelete(item)"
                    ></v-btn>
                  </div>
                  <div class="actions">
                    <v-tooltip activator="parent" location="top"
                      >Editar</v-tooltip
                    >
                    <v-btn
                      class="edit"
                      icon="mdi-pencil"
                      color="indigo-darken-3"
                      @click="openDialogRegistrar('edit', item)"
                    ></v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>

  <!-- Dialog de registro-->
  <template>
    <v-dialog width="650" v-model="showDialogRegistrar">
      <v-card :title="tituloRegistroEdit">
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-container>
            <v-row v-if="!loadingRegistro">
              <v-col cols="12">
                <label>Lugar</label>
                <v-text-field
                  id="lugarMinuta"
                  v-model="lugarMinuta"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Fecha de Reunión</label>
                <v-text-field
                  v-model="fechaMinuta"
                  placeholder="Clic para seleccionar la fecha"
                  readonly
                  @click="openDialogDate()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Asistentes Internos</label>
                <v-autocomplete
                  v-model="idUsuario"
                  label="Seleccione uno..."
                  variant="outlined"
                  :items="listUsers"
                  item-title="nombre"
                  item-value="id"
                  prepend-inner-icon="mdi-magnify"
                  chips
                  closable-chips
                  multiple
                  class="autocomplete-custom-style"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <label>Asistentes Externos</label>
                <v-tooltip activator="parent" location="top"
                  >Separar los nombres con una coma <b>","</b></v-tooltip
                >
                <v-text-field v-model="usuariosC"> </v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Objetivo</label>
                <v-textarea
                  id="objetivoMinuta"
                  v-model="objetivoMinuta"
                  required
                  rows="2"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <label>Temas a Discutir</label>
                <v-textarea
                  required
                  v-model="temasDiscusion"
                  rows="2"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <label>Asuntos</label>
                <v-textarea
                  required
                  v-model="asuntosMinutas"
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
            <div class="content_load" v-if="loadingRegistro">
              <v-progress-circular
                :size="100"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <i>Espere un momento</i>
            </div>
          </v-container>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialogRegistrar"
          ></v-btn>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            :loading="isLoading"
            @click="validateInputs()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!-- Seleccione una Fecha -->
  <template>
    <v-dialog v-model="dialogDate" width="400px" persistent>
      <v-card>
        <v-card-title>
          <div>
            <span class="text-h5">Seleccione una Fecha</span>
          </div>
        </v-card-title>

        <v-card-text>
          <v-date-picker v-model="inputDate" @click="selectedDate()">
          </v-date-picker>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Aceptar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            @click="closeDialogDate"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!--Dialog de eliminacion-->
  <template>
    <v-dialog v-model="dialogDelete" width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div v-if="!isLoadingEliminar">
            <div class="text-center">
              <img src="@/assets/images/warning.png" />
            </div>
            <div class="description-text">
              <p>¿Está seguro de eliminar la minuta?</p>
            </div>
          </div>
          <div class="content_load" v-if="isLoadingEliminar">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <i>Espere un momento</i>
          </div>
        </v-card-text>
        <v-card-actions class="actions-buttons">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogDelete = false"
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            >Cerrar</v-btn
          >
          <v-btn
            :loading="isLoadingEliminar"
            @click="delteMinuta"
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>

<script>
import { MinutasService } from "@/services/MinutasService";
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";

export default {
  name: "MinutasAdminComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      listAllMinutas: [],
      loadingMinutas: true,
      headerMinutas: [
        { title: "Objetivo", key: "objetivo_minuta" },
        { title: "Lugar", key: "lugar_minuta" },
        { title: "Fecha de Reunión", key: "fecha_minuta" },
        { title: "Última Actualización", key: "ultimaActualizacion" },
        { title: "Acciones", key: "actions" },
      ],
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      search: "",
      loadingRegistro: false,
      lugarMinuta: "",
      objetivoMinuta: "",
      fechaMinuta: "",
      temasDiscusion: "",
      asuntosMinutas: "",
      asistentesMinuta: "",
      idUsuario: [],
      showDialogRegistrar: false,
      tituloRegistroEdit: "Crear Minuta",
      dialogDate: false,
      inputDate: new Date(),
      //minDate: new Date(new Date().getTime()).toISOString().substr(0, 10), // Establece la fecha mínima como la de hoy
      listUsers: [],
      usuariosC: "",
      dialogDelete: false,
      isLoadingEliminar: false,
      idMinutaGlobal: "",
      formMode: "registrar",
      dialogAdd: false,
      searchAdd: "",
    };
  },
  beforeMount() {
    this.getMinutas();
    this.getUsers();
  },
  methods: {
    getMinutas: async function () {
      this.loadingMinutas = true;
      await MinutasService.getAllMinutas()
        .then((resp) => {
          if (!resp.error) {
            this.listAllMinutas = resp.response;
            this.listAllMinutas.forEach((element) => {
              if (element.editado_por !== null) {
                element.ultimaActualizacion = element.editado_por;
              } else {
                element.ultimaActualizacion = element.agregado_por;
              }
            });
            setTimeout(() => {
              this.loadingMinutas = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.search = "";
    },
    saveMinutas: async function () {
      const dataForm = new FormData();
      this.loadingRegistro = true;
      this.loadingMinutas = true;
      dataForm.append("lugar_minuta", this.lugarMinuta);
      dataForm.append("objetivo_minuta", this.objetivoMinuta);
      dataForm.append("fecha_minuta", this.fechaMinuta);
      dataForm.append("agregado_por", localStorage.getItem("USERNAME"));
      dataForm.append("temas_discusion", this.temasDiscusion);
      dataForm.append("asuntos", this.asuntosMinutas);
      dataForm.append("asistentes", this.asistentesMinuta);

      await MinutasService.saveMinuta(dataForm)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se registró la minuta exitosamente!",
            };
            this.getMinutas();
            setTimeout(() => {
              this.loadingMinutas = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.loadingRegistro = false;
      this.formMode = "registrar";
      this.closeDialogRegistrar();
    },
    editMinutas: async function () {
      const dataForm = new FormData();
      this.loadingRegistro = true;
      this.loadingMinutas = true;
      let idMin = await MinutasService.encriptar(this.idMinutaGlobal);
      dataForm.append("lugar_minuta", this.lugarMinuta);
      dataForm.append("objetivo_minuta", this.objetivoMinuta);
      dataForm.append("fecha_minuta", this.fechaMinuta);
      dataForm.append("editado_por", localStorage.getItem("USERNAME"));
      dataForm.append("temas_discusion", this.temasDiscusion);
      dataForm.append("asuntos", this.asuntosMinutas);
      dataForm.append("asistentes", this.asistentesMinuta);

      await MinutasService.editMinuta(idMin.msg, dataForm)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se editó la minuta exitosamente!",
            };
            this.getMinutas();
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.search = "";
      this.closeDialogRegistrar();
      this.loadingRegistro = false;
      this.loadingMinutas = false;
      this.formMode = "registrar";
    },
    delteMinuta: async function () {
      let idMinuta = await MinutasService.encriptar(this.idMinutaGlobal);
      this.isLoadingEliminar = true;
      this.loadingMinutas = true;
      await MinutasService.deleteMinuta(idMinuta.msg)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se eliminó la minuta exitosamente!",
            };
            this.getMinutas();
            setTimeout(() => {
              this.loadingMinutas = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema 0005",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.dialogDelete = false;
      this.isLoadingEliminar = false;
      this.search = "";
    },
    openDialogRegistrar(tipo, data) {
      if (tipo == "edit") {
        this.tituloRegistroEdit = "Editar Minuta";
        this.formMode = tipo;
        this.idMinutaGlobal = data.id_minuta;
        this.lugarMinuta = data.lugar_minuta;
        this.fechaMinuta = data.fecha_minuta;
        this.objetivoMinuta = data.objetivo_minuta;
        this.asuntosMinutas = data.asuntos;
        this.temasDiscusion = data.temas_discusion;
        this.asistentesMinuta = data.asistentes.split(",");
        this.asistentesMinuta.forEach((element) => {
          const usuario = this.listUsers.find(
            (user) => user.nombre === element
          );
          if (usuario) {
            this.idUsuario[usuario.id] = usuario.id;
          } else {
            this.usuariosC += element + ", ";
          }
        });
      }
      this.showDialogRegistrar = true;
    },
    closeDialogRegistrar() {
      this.showDialogRegistrar = false;
      this.lugarMinuta = "";
      this.fechaMinuta = "";
      this.idUsuario = [];
      this.usuariosC = "";
      this.asistentesMinuta = "";
      this.objetivoMinuta = "";
      this.asuntosMinutas = "";
      this.temasDiscusion = "";
      this.formMode = "registrar";
    },
    openDialogDate() {
      this.dialogDate = true;
    },
    closeDialogDate() {
      this.inputDate = new Date();
      this.dialogDate = false;
    },
    selectedDate: function () {
      const YEAR_INPUT = this.inputDate.getFullYear();
      const MONTH_INPUT = ("0" + (this.inputDate.getMonth() + 1)).slice(-2);
      const DAY_INPUT = ("0" + this.inputDate.getDate()).slice(-2);
      const DATE_SELECTED = `${YEAR_INPUT}-${MONTH_INPUT}-${DAY_INPUT}`;
      this.fechaMinuta = DATE_SELECTED;
    },
    validateInputs() {

      if (this.lugarMinuta === "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "El lugar es requerido",
        };
        return false;
      }

      if (this.objetivoMinuta === "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "El objetivo es requerido",
        };
        return false;
      }

      if (this.fechaMinuta === "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "La fecha de la reunión es requerido",
        };
        return false;
      }

      let datos = this.concatenarAsistentes();
      if (datos.length === 0) {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "Debe agregar al menos un asistente interno",
        };
        return false;
      }

      this.asistentesMinuta = datos + "," + this.usuariosC;

      if (this.formMode === "edit") {
        this.editMinutas();
      } else {
        this.saveMinutas();
      }
    },
    getUsers: async function () {
      await MinutasService.getUsers()
        .then((resp) => {
          if (!resp.error) {
            this.listUsers = resp.response;
            this.listUsers.forEach((element) => {
              element.nombre = element.name + " " + element.last_name;
            });
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    concatenarAsistentes() {
      let arrUC = [];
      this.idUsuario.forEach((userId) => {
        this.listUsers.forEach((user) => {
          if (user.id === userId) {
            arrUC.push(`${user.name} ${user.last_name}`);
          }
        });
      });

      return arrUC.join(",");
    },
    openDialogDelete(item) {
      this.idMinutaGlobal = item.id_minuta;
      this.dialogDelete = true;
    },
  },
};
</script>

<style scoped>
.filter {
  width: 300px;
}

.content_table {
  overflow: auto;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.select {
  float: left;
  margin-right: 2vh;
  width: 60vh;
}

.buscar {
  float: left;
  margin-right: 2vh;
  width: 20vh;
}

.reload {
  margin-top: -2vh;
}

.actions {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 1vh;
  width: 9vh !important;
  height: 9vh !important;
}

img {
  height: 230px;
  width: auto;
  padding: 40px;
}

.autocomplete-custom-style {
  max-height: 12vh; /* Establece la altura máxima deseada */
  overflow-y: auto;
}
</style>
